import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import OrganisationSlideModal from '../organisation/OrganisationSlideModal';
import OrganisationModal from '../organisation/OrganisationModal';
import ContactModal from '../../contact/ContactModal';

import { FaPlus } from "react-icons/fa";
import Offcanvas from 'react-bootstrap/Offcanvas';

import axios from 'axios';
const LeadModal = ({
    showModal,
    handleClose,
    leadId,
    leadData,
    addLead,
    editLead,
    leads,
    contacts,
    organisations,
    fetchOrganisation,
    fetchContacts,
    setShowModal, setOrganisation, setContacts

}) => {
    const [formData, setFormData] = useState({
        organisation_id: '',
        contact_id: '',
        status: '',
        description: '',
        name: '',
        notes: '',
        lead_source: '',
        company: '',
        partner_id: '',



    });
    const [contactFormData, setContactFormData] = useState({
        name: '',
        email: '',
        phone: '',
        position: '',
        contact_type: '',
        external_type: ''
    });
    const [errors, setErrors] = useState({});
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [showOrgModal, setShowOrgModal] = useState(false);
    const [isLeadModalHidden, setIsLeadModalHidden] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [showContactModal, setShowContactModal] = useState(false);

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            allIndustries = [...allIndustries, ...response.data.industry]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };
    useEffect(() => {
        if (showModal && organisations?.length === 0) {
            fetchOrganisation();
        }
        if (showModal && contacts?.length === 0) {
            fetchContacts();
        }
        if (showModal && !leadData) {
            // Reset formData for new orgs creation
            setFormData({
                organisation_id: '',
                contact_id: '',
                status: '',
                description: '',
                name: '',
                notes: '',
                lead_source: '',
                company: '',
                partner_id: '',
            });
            setFilteredContacts([]);

        } else if (leadData) {
            // Populate formData for editing a orgs
            setFormData({
                organisation_id: leadData.organisation_id || '',
                contact_id: leadData.contact_id || '',
                status: leadData.status || '',
                notes: leadData.notes || '',
                name: leadData.name || '',
                description: leadData.description || '',
                lead_source: leadData.lead_source || '',
                company: leadData.company || '',
                contacts: leadData.contacts || [],
                partner_id: leadData.partner_id || '',

            });
        }
    }, [leadData, showModal]);
    useEffect(() => {
        if (showModal && !leadData) {
            setFormData((prev) => ({
                ...prev,
                contact_id: prev.contact_id || '',
            }));
            console.log("📌 Restoring selected contact_id:", formData.contact_id); // Debugging
        }
    }, [showModal]);

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setContactFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleOrgModalClose = (newOrg) => {
        setShowOrgModal(false);

        if (newOrg) {
            setOrganisation((prev) => [...prev, newOrg]); // Add new org to the list

            // Ensure formData is updated with the new org ID
            setFormData((prev) => ({
                ...prev,
                organisation_id: newOrg.id,
                contact_id: ''
            }));
            setFilteredContacts(newOrg.contacts || []);

        }
        setIsLeadModalHidden(false);
    };
    const [selectedContacts, setSelectedContacts] = useState([]);


    const handleContactModalClose = (newContact) => {
        setShowContactModal(false);

        if (newContact) {
            console.log("✅ New contact created:", newContact);

            // ✅ Update contacts list with new contact
            setContacts((prev) => [newContact, ...prev]);

            // ✅ Ensure new contact is added to filteredContacts
            setFilteredContacts((prevContacts) => {
                if (!prevContacts.some(contact => contact.id === newContact.id)) {
                    return [...prevContacts, newContact];
                }
                return prevContacts;
            });

            // ✅ Update formData with the new contact ID
            setFormData((prev) => ({
                ...prev,
                contact_id: newContact.id, // Ensure this is set correctly
            }));

            console.log("Updated formData.contact_id:", formData.contact_id);
            console.log("Updated filteredContacts:", filteredContacts);
        }

        // ✅ Ensure modal is reopened after updates
        setIsLeadModalHidden(false);
        setShowModal(true);
    };
    useEffect(() => {
        console.log("📌 formData.contact_id updated:", formData.contact_id);
    }, [formData.contact_id]);


    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);


    useEffect(() => {
        const leadSource = formData.lead_source?.toLowerCase();

        if (leadSource === 'partner' && formData.partner_id) {
            const partnerOrganisation = organisations.find(
                (org) => String(org.id) === String(formData.partner_id)
            );

            if (partnerOrganisation?.org_type?.toLowerCase() === 'partner') {
                setFilteredContacts(partnerOrganisation.contacts || []);
            }
        }
        else if (leadSource === 'consultant') {
            setFilteredContacts(
                contacts.filter(contact =>
                    contact.contact_type?.toLowerCase() === 'external' &&
                    (contact.type?.name?.toLowerCase() || '') === 'consultant' // ✅ Default empty string
                )
            );
        }
        else if (leadSource === 'inside sales') {
            setFilteredContacts(
                contacts.filter(contact =>
                    contact.contact_type?.toLowerCase() === 'internal' &&
                    (contact.type?.name?.toLowerCase() || '') === 'inside sales' // ✅ Default empty string
                )
            );
        }
        else if (leadSource === 'sales generated') {
            setFilteredContacts(
                contacts.filter(contact =>
                    contact.contact_type?.toLowerCase() === 'internal' &&
                    (contact.type?.name?.toLowerCase() || '') === 'sales generated' // ✅ Default empty string
                )
            );
        }
        else {
            const selectedOrg = organisations.find(
                (org) => String(org.id) === String(formData.organisation_id)
            );
            setFilteredContacts(selectedOrg?.contacts || []);
        }
    }, [organisations, formData.organisation_id, formData.partner_id, contacts, formData.lead_source]);

    const validateform = () => {
        const newErrors = {};
        if (!contactFormData.name) newErrors.name = 'Name is required';
        if (!contactFormData.email) newErrors.email = 'Email is required';
        if (!contactFormData.phone) newErrors.phone = 'Phone is required';



        return newErrors;
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.organisation_id && !formData.contact_id) {
            newErrors.organisation_id = 'required';
            newErrors.contact_id = 'required';
        }

        return newErrors;
    };
    const [loading, setLoading] = useState(false);
    const addOrganisation = async (newOrganisation) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Send newOrganisation as JSON (not FormData)
            const response = await axios.post(`${backendUrl}/api/organisation`, newOrganisation, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json', // Ensure correct content type
                    'Tenant-Origin': origin,

                },
            });

            const createdOrganisation = response.data.data;

            if (createdOrganisation) {
                setOrganisation((prevOrganisation) => [...prevOrganisation, createdOrganisation]);
                setFormData(prev => ({ ...prev, organisation_id: createdOrganisation.id }));
            } else {
                console.error('Creation failed, no data returned.');
            }

            setShowOrgModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };

    const [isEdit, setIsEdit] = useState(false);


    const handleSumbit = async () => {
        console.log("🚀 handleSumbit function triggered");
        setLoading(true);

        const validationErrors = validateform();
        if (Object.keys(validationErrors).length > 0) {
            console.log("❌ Validation errors:", validationErrors);
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info') || '{}');
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let response;
            let newContact = null;

            if (!isEdit) {
                console.log("🔹 Creating new contact with data:", contactFormData);
                response = await axios.post(`${backendUrl}/api/contact`, contactFormData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                newContact = response?.data?.contact;
                if (!newContact) throw new Error("Invalid response from server");

                console.log("✅ Contact created successfully:", newContact);

                // ✅ Update contacts list with new contact
                setContacts((prev) => [newContact, ...prev]);
                setFormData(prev => ({ ...prev, contact_id: newContact.id }));

                // ✅ Ensure new contact is added to filteredContacts
                setFilteredContacts((prevContacts) => {
                    if (!prevContacts.some(contact => contact.id === newContact.id)) {
                        return [...prevContacts, newContact];
                    }
                    return prevContacts;
                });
            }

            setErrors({});
            setShowContactModal(false); // ✅ Close contact modal
            handleContactModalClose(newContact); // ✅ Pass new contact to the modal close function

        } catch (error) {
            console.error("❌ Error adding/updating contact:", error);
            setErrors({ apiError: "Failed to save contact. Please try again." });
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Show loading state

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop if validation fails
        }

        // Get the selected contact from the dropdown
        const selectedContact = filteredContacts.find(
            (contact) => String(contact.id) === String(formData.contact_id)
        );

        // Check if a new contact was created
        const newContact = formData.newContact
            ? { id: formData.newContact.id, position: formData.newContact.position || '' }
            : null;

        // Use the new contact if available, otherwise use the selected contact
        const contactToAdd = newContact || selectedContact;

        const updatedData = {
            ...formData,
            contacts: contactToAdd
                ? [{ id: contactToAdd.id, position: contactToAdd.position || '' }]
                : []
        };

        let errors;
        if (leadData) {
            errors = await editLead(leadData.id, updatedData);
        } else {
            errors = await addLead(updatedData);
        }

        if (errors && Object.keys(errors).length > 0) {
            setErrors(errors); // Show validation errors
        } else {
            setErrors({}); // Clear errors on success
            handleClose(); // Close modal
        }

        setLoading(false); // Remove loading state
    };


    const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');
    const partnerContacts = contacts?.filter(contact => contact.external_type === 'partner');

    console.log("🚀 Checking filteredContacts before selecting contact:");
    console.log(filteredContacts);
    console.log("Trying to find contact with ID:", formData.contact_id);

    const selectedContact = filteredContacts.find(contact =>
        String(contact.id) === String(formData.contact_id)
    );

    console.log("🔍 Selected contact in dropdown:", selectedContact); // Should NOT be undefined

    const dropdownValue = selectedContact
        ? { value: selectedContact.id, label: selectedContact.name || "Unknown Contact" }
        : null;
    return (
        <>
            <div>
                {showModal && (
                    <div
                    className="custom-backdrop"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.25)', // light dim (Bootstrap style)
                        zIndex: 1059, // between parent & child offcanvas
                    }}
                    />
                )}
            </div>

            {
                showModal && (
                    <Offcanvas show={showModal && !isLeadModalHidden} onHide={handleClose} placement="end" style={{ width: '450px' }} enforceFocus={false} backdrop="static">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                                {leadId ? 'Edit Lead' : 'Add Lead'}
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <hr style={{ margin: 0 }} /><br />
                        <Offcanvas.Body>
                            <form >



                                <div className="form-group mb-3">
                                    <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>Name:</label>
                                    <input
                                        type='text'
                                        style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        value={formData.name}
                                        onChange={handleChange}

                                    />
                                </div>



                                <div className="form-group mb-3">
                                    <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>Organisation</label>

                                    <div className={`form-control p-0 border-0 ${errors?.organisation_id ? 'is-invalid' : ''}`} style={{ borderRadius: '14px' }}>
                                        <CreatableSelect
                                            key={formData.organisation_id}
                                            isClearable

                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    fontSize: '14px',
                                                    // maxWidth: '320px',
                                                    borderRadius: '14px',
                                                    height: '39px',
                                                    border: '0.5px solid rgb(232, 233, 237)',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '320px', // same width as the control
                                                    borderRadius: '14px'
                                                })
                                            }}
                                            options={[
                                                { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                                ...organisations.map(org => ({
                                                    value: org.id,
                                                    label: org.name,
                                                }))
                                            ]}
                                            value={
                                                formData.organisation_id && formData.organisation_id !== "create_new"
                                                    ? {
                                                        value: formData.organisation_id,
                                                        label: organisations.find(org => org.id === formData.organisation_id)?.name || "Loading..."
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                if (!selectedOption) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        organisation_id: '',
                                                        contact_id: ''
                                                    }));
                                                    setFilteredContacts([]);
                                                    return;
                                                }
                                                if (selectedOption?.value === "create_new") {
                                                    setIsLeadModalHidden(true);
                                                    setShowOrgModal(true);
                                                    return;
                                                } else {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        organisation_id: selectedOption ? selectedOption.value : ''
                                                    }));
                                                    const selectedOrg = organisations?.find(org => String(org.id) === String(selectedOption.value));
                                                    if (selectedOrg && selectedOrg.contacts) {
                                                        setFilteredContacts(selectedOrg.contacts);
                                                        console.log("Filtered Contacts: ", selectedOrg.contacts);
                                                    } else {
                                                        setFilteredContacts([]);
                                                        console.log("Filtered Contacts: []");
                                                    }
                                                }
                                            }}
                                            placeholder="Select"
                                        />
                                    </div>
                                    {errors.organisation_id && (
                                        <div className="invalid-feedback" style={{ fontSize: '12px' }}>
                                            *{errors.organisation_id}
                                        </div>
                                    )}



                                </div>





                                <div className="form-group mb-3">
                                    <label htmlFor="lead_source" className="form-label" style={{ fontSize: '13px' }}>Lead Source:</label>
                                    <select
                                        style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="lead_source"
                                        id="lead_source"
                                        className="form-control"
                                        value={formData.lead_source}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select </option>
                                        <option value="partner">Partner </option>
                                        <option value="consultant">Consultant </option>
                                        <option value="inside sales">Inside Sales </option>
                                        <option value="sales generated">Sales Generated </option>




                                    </select>

                                </div>

                                {formData.lead_source === 'partner' && (
                                    <div className="form-group mb-3">
                                        <label htmlFor="partner_id" className="form-label" style={{ fontSize: '13px' }}>Select Partner:</label>
                                        <select
                                            style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}

                                            name="partner_id"
                                            id="partner_id"
                                            className="form-control"
                                            value={formData.partner_id}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select a Partner</option>
                                            {partnerOrganisations.map(org => (
                                                <option key={org.id} value={org.id}>
                                                    {org.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>


                                )}



                                {/* <div className="form-group mb-3">
                                <label htmlFor="contact_id" className="form-label" style={{ fontSize: '13px' }}>Contact</label>
                                <select
                                    style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="contact_id"
                                    id="contact_id"
                                    className={`form-control ${errors?.contact_id ? 'is-invalid' : ''}`}
                                    value={formData.contact_id}
                                    onChange={handleChange}
                                >
                                    <option value="">Select </option>

                                    {filteredContacts.map(contact => (
                                        <option key={contact.id} value={contact.id}>
                                            {contact.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.contact_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.contact_id}</div>}

                            </div> */}
                                <div className="form-group mb-3">
                                    <label htmlFor="contact_id" className="form-label" style={{ fontSize: '13px' }}>Contact</label>

                                    <div className={`form-control p-0 border-0 ${errors?.contact_id ? 'is-invalid' : ''}`} style={{ borderRadius: '14px' }}>
                                        {/* <CreatableSelect
                                       key={filteredContacts.length}
                                        isClearable
                                        menuPortalTarget={document.body} 

                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                fontSize: '14px',
                                                borderRadius: '14px',
                                                height: '39px',
                                                border: '0.5px solid rgb(232, 233, 237)',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '320px',
                                                borderRadius: '14px',
                                            }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }) 

                                        }}
                                        options={[
                                            { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                            ...filteredContacts.map(contact => ({
                                                value: contact.id,
                                                label: contact.name,
                                            })),
                                        ]}
                                        value={
                                            formData.contact_id && formData.contact_id !== "create_new"
                                                ? {
                                                    value: formData.contact_id,
                                                    label: filteredContacts.find(contact => contact.id === formData.contact_id)?.name || " "
                                                }
                                                : null
                                        }
                                        onChange={(selectedOption) => {
                                            if (!selectedOption) {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    contact_id: '',
                                                }));
                                                return;
                                            }
                                            if (selectedOption?.value === "create_new") {
                                                setShowContactModal(true); // Open the ContactModal to create a new contact
                                                return;
                                            } else {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    contact_id: selectedOption.value, // Set the selected contact ID
                                                }));
                                            }
                                        }}
                                        placeholder="Select"
                                    /> */}


                                        <CreatableSelect
                                            key={filteredContacts.length}
                                            isClearable
                                            menuPortalTarget={document.body}

                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    fontSize: '14px',
                                                    borderRadius: '14px',
                                                    height: '39px',
                                                    border: '0.5px solid rgb(232, 233, 237)',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: '320px',
                                                    borderRadius: '14px',
                                                }),
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                            }}

                                            options={[
                                                { value: "create_new", label: <><FaPlus color="gray" /> Add new</> },
                                                ...filteredContacts.map(contact => ({
                                                    value: contact.id,
                                                    label: contact.name,
                                                })),
                                            ]}

                                            value={
                                                formData.contact_id && formData.contact_id !== "create_new"
                                                    ? {
                                                        value: formData.contact_id,
                                                        label: filteredContacts.find(contact => contact.id === formData.contact_id)?.name ||
                                                            contacts.find(contact => contact.id === formData.contact_id)?.name || // ✅ Fallback
                                                            "New Contact"
                                                    }
                                                    : null
                                            }

                                            onChange={(selectedOption) => {
                                                if (!selectedOption) {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        contact_id: '',
                                                    }));
                                                    return;
                                                }
                                                if (selectedOption?.value === "create_new") {
                                                    setIsLeadModalHidden(true);
                                                    setShowContactModal(true); // Open the ContactModal to create a new contact
                                                    return;
                                                } else {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        contact_id: selectedOption.value, // Set the selected contact ID
                                                    }));
                                                }
                                            }}

                                            placeholder="Select Contact"
                                        />



                                    </div>

                                   
                                </div>


                                {/* <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="status" className="form-label" style={{ fontSize: '13px' }}>Status:</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    type="text"
                                    name="status"
                                    className="form-control"
                                    value={formData.status}
                                    onChange={handleChange}
                                />
                            </div>
                        </div> */}


                                <div className="form-group mb-3">
                                    <label htmlFor="notes" className="form-label" style={{ fontSize: '13px' }}>Notes:</label>
                                    <textarea
                                        style={{ fontSize: '14px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="notes"
                                        id="notes"
                                        className="form-control"
                                        value={formData.notes}
                                        onChange={handleChange}

                                    />
                                </div>



                                {/* <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="description" className="form-label" style={{ fontSize: '13px' }}>Description:</label>
                                <textarea
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="description"
                                    id="description"
                                    className="form-control"
                                    value={formData.description}
                                    onChange={handleChange}

                                />
                            </div>
                        </div> */}
                            </form>
                        </Offcanvas.Body>
                        <div className="p-3 d-flex justify-content-end border-top">

                            <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                                Close
                            </button>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                Save
                            </button>
                        </div>

                    </Offcanvas>
                )
            }
            {
                showOrgModal && (
                    <OrganisationModal
                        showModal={showOrgModal}
                        handleClose={handleOrgModalClose}
                        fetchIndustries={fetchIndustries}
                        industries={industries}
                        addOrg={addOrganisation}

                    />
                )
            }
            {
                showContactModal && (
                    <ContactModal
                        showModal={showContactModal}
                        handleClose={handleContactModalClose}
                        handleSubmit={handleSumbit}
                        formData={contactFormData}
                        handleInputChange={handleInputChange}
                        errors={errors}
                        isEdit={isEdit}

                    />
                )
            }
        </>
    );
};

export default LeadModal;
